import { render, staticRenderFns } from "./shopModuleList.vue?vue&type=template&id=3165f5ac"
import script from "./shopModuleList.vue?vue&type=script&lang=js"
export * from "./shopModuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports